/* Bauchemie.at – Verbrauchsrechner (mrk.js v4.8, ohne jQuery)
 * Komplettsets: Rechner kommt fertig aus snippets/mrk_total.liquid (Kauf erst nach m²-Eingabe).
 * Einzelprodukte: Rechner wird an der Stelle des App-Blocks aufgebaut (optional, Menge wird gesetzt).
 * Keine externe App/API nötig – der Rechner ist sofort da.
 * Texte kommen aus window.mrkT (snippets/mrk-i18n.liquid + snippets/mrk-t.liquid) in der Shop-Sprache.
 */
(function () {
  'use strict';
  if (window.__mrkLoaded) return;
  window.__mrkLoaded = true;

  var T = function (k, x) { var s = (window.mrkT && window.mrkT[k]) || k; return x != null ? s.replace('{x}', x) : s; };
  var fmt = new Intl.NumberFormat('de-AT', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return fmt.format((cents || 0) / 100); };
  var num = function (v) { var n = parseFloat(String(v).replace(',', '.')); return isNaN(n) ? 0 : n; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var fmtArea = function (a) { return String(Math.round(a * 100) / 100).replace('.', ','); };

  var root, input, panel, atcOriginalText = null, qtyTouched = false;
  var isSet = !!window.mrkIsSet;

  function form() {
    return document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function atc() { return document.querySelector('button[name="add"]'); }
  function variantId() { var f = form(); var el = f ? f.querySelector('[name="id"]') : null; return el ? el.value : ''; }

  function qtyInput() {
    var f = form();
    if (!f) return null;
    var q = quantityFields()[0]; // auch Felder außerhalb des Formulars mit form="…"
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden'; q.name = 'quantity'; q.value = '1'; q.id = 'mrk-qty';
      f.appendChild(q);
    }
    return q;
  }

  function dimPerUnit() {
    var m = window.mrkDimByVariant || {};
    return num(m[variantId()]) || num(window.mrkDimPerUnit) || 2;
  }
  function quantityFields() {
    var f = form();
    if (!f) return [];
    return Array.prototype.filter.call(f.elements, function (e) { return e.name === 'quantity'; });
  }

  function selectedVariantLabel() {
    var checked = document.querySelector('variant-selects input[type="radio"]:checked');
    if (checked) return checked.value;
    var sel = document.querySelector('variant-selects select');
    return sel ? sel.value : '';
  }

  /* ---------- Berechnung ---------- */
  function calculate() {
    var area = num(input ? input.value : 0);
    var quantity = area > 0 ? Math.ceil(Math.round(area / dimPerUnit() * 1000) / 1000) : 0;

    var vp = window.mrkVariantPrice || {};
    var unitPrice = vp[variantId()] != null ? vp[variantId()] : num(window.mrkMainProductPrice);
    var total = unitPrice * quantity, items = [];

    function push(prod, n) {
      if (!prod || n <= 0) return;
      items.push({ id: prod.id, quantity: n, title: String(prod.title).trim() });
      total += n * prod.unit_price;
    }

    var binders = window.stone_binders || [];
    var find = function (q) { return binders.filter(function (b) { return b.unit_qty === q; })[0]; };
    var large = find(20), medium = find(10), small = find(2);
    var rest = quantity * 2; // 1 Stück = 2 m² Bindemittelbedarf (wie bisher)
    if (large) { var nl = Math.floor(rest / 20); push(large, nl); rest -= nl * 20; }
    if (medium) { var nm = Math.floor(rest / 10); push(medium, nm); rest -= nm * 10; }
    if (small) { push(small, rest > 0 ? Math.ceil(rest / 2) : 0); }

    (window.addons || []).forEach(function (a) { push(a, area > 0 ? Math.ceil(area / a.unit_qty) : 0); });

    return { area: area, quantity: quantity, items: items, total: total };
  }

  /* ---------- Darstellung ---------- */
  function render() {
    var r = calculate();

    if (isSet || r.quantity > 0) {
      qtyInput(); // sicherstellen, dass ein Mengenfeld im Formular existiert
      quantityFields().forEach(function (q) { q.value = Math.max(r.quantity, 1); });
      qtyTouched = true;
    } else if (qtyTouched) { // Einzelprodukt: Fläche gelöscht -> Menge zurück auf 1
      quantityFields().forEach(function (q) { q.value = 1; });
      qtyTouched = false;
    }

    var hidden = document.querySelector('.mrk-hidden-inputs');
    if (hidden) {
      hidden.innerHTML = '';
      r.items.forEach(function (it, i) {
        hidden.insertAdjacentHTML('beforeend',
          '<input name="items[' + (i + 1) + '][id]" value="' + it.id + '" type="hidden" />' +
          '<input name="items[' + (i + 1) + '][quantity]" value="' + it.quantity + '" type="hidden" />');
      });
    }

    if (panel) {
      if (r.area > 0 && r.quantity > 0) {
        var variant = selectedVariantLabel();
        var mainLabel = (window.mrkMainLabel || T('main_fallback')) + (variant && variant !== 'Default Title' ? ' – ' + variant : '');
        var rows = '<li><span class="mrk-qty">' + r.quantity + '×</span><span>' + esc(mainLabel) + '</span></li>';
        var listTitle = isSet ? T('in_set') : T('needed');
        r.items.forEach(function (it) {
          rows += '<li><span class="mrk-qty">' + it.quantity + '×</span><span>' + esc(it.title) + '</span></li>';
        });
        panel.innerHTML =
          '<div class="mrk-price-row"><span class="mrk-total">' + money(r.total) + '</span>' +
          '<span class="mrk-per-m2">≈ ' + money(r.total / r.area) + ' / m²</span></div>' +
          '<div class="mrk-price-note">' + esc(T('vat_note', fmtArea(r.area))) + '</div>' +
          '<div class="mrk-list-title">' + esc(listTitle) + '</div><ul class="mrk-list">' + rows + '</ul>';
        panel.hidden = false;
      } else {
        panel.innerHTML = '';
        panel.hidden = true;
      }
    }
    updateButton(r);
  }

  function updateButton(r) {
    var btn = atc();
    if (!btn) return;
    var span = btn.querySelector('span');
    var avail = window.mrkVariantAvail || {};
    var hint = document.querySelector('.mrk-atc-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'mrk-atc-hint';
      hint.textContent = T('area_hint');
      hint.hidden = true;
      var wrap = btn.closest('.product-form__buttons') || btn.parentNode;
      wrap.parentNode.insertBefore(hint, wrap.nextSibling);
    }
    var CHOOSE = T('choose');
    var AREA = T('area_btn');
    if (span && atcOriginalText === null && span.textContent.trim() !== CHOOSE && span.textContent.trim() !== AREA) atcOriginalText = span.textContent.trim();
    if (window.mrkNeedsVariant) { // Farbe noch nicht gewählt (snippets/mrk-variant-choice.liquid)
      btn.disabled = true;
      if (span) span.textContent = CHOOSE;
      hint.hidden = true; // Hinweis steht oben bei der Farbe und im Button
      return;
    }
    hint.textContent = T('area_hint');
    if (avail[variantId()] === false) { btn.disabled = true; hint.hidden = true; return; } // ausverkauft: Theme-Text bleibt
    var valid = r.area >= 1 && r.quantity > 0;
    if (!isSet) { // Einzelprodukt: Rechner ist optional, Button nie sperren
      hint.hidden = true;
      if (span && atcOriginalText !== null) span.textContent = valid ? T('add_pcs', r.quantity) : atcOriginalText;
      return;
    }
    btn.disabled = !valid;
    btn.style.opacity = valid ? '' : '0.45';
    btn.style.cursor = valid ? '' : 'not-allowed';
    if (span) span.textContent = valid ? T('add_area', fmtArea(r.area)) : AREA;
    hint.hidden = true; // Hinweis steht im Button
  }

  var timer;
  function scheduleRender() { clearTimeout(timer); timer = setTimeout(render, 80); }

  /* Einzelprodukte: Rechner an der Stelle des App-Blocks einsetzen */
  function buildCalculator() {
    var host = document.querySelector('#entangle_floor_calculator');
    if (!host || !window.mrkDimByVariant) return null;
    var box = document.createElement('div');
    box.className = 'entangle-cal-flooring mrk-calc mrk-native';
    box.innerHTML =
      '<div class="entangle-b2-calculator">' +
      '<div class="entangle-pc-heading"><p>' + esc(T('calc_title')) + '</p></div>' +
      '<p class="mrk-help">' + esc(T('calc_help')) + '</p>' +
      '<div class="mrk-stepper"><button type="button" class="mrk-step" data-step="-1" aria-label="' + esc(T('dec')) + '">−</button>' +
      '<div class="mrk-field"><input type="text" name="area" class="entangle-input" inputmode="decimal" enterkeyhint="done" placeholder="' + esc(T('placeholder')) + '" aria-label="' + esc(T('area_label')) + '" autocomplete="off"><span class="mrk-unit">m²</span></div>' +
      '<button type="button" class="mrk-step" data-step="1" aria-label="' + esc(T('inc')) + '">+</button></div>' +
      '<div class="mrk-panel" hidden aria-live="polite"></div></div>';
    host.parentNode.insertBefore(box, host);
    return box;
  }

  /* ---------- Start ---------- */
  function init() {
    root = document.querySelector('.mrk-native');
    if (!root) root = buildCalculator();
    if (!root) return;
    input = root.querySelector('.entangle-input');
    panel = root.querySelector('.mrk-panel');

    input.addEventListener('input', function () {
      // nur Ziffern und ein Komma/Punkt zulassen (Handy-Tastatur liefert je nach Sprache , oder .)
      var v = input.value.replace(/[^0-9.,]/g, '').replace(/([.,].*)[.,]/g, '$1');
      if (v !== input.value) input.value = v;
      scheduleRender();
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    input.addEventListener('change', scheduleRender);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.mrk-step');
      if (!b) return;
      var v = Math.max(0, Math.round(num(input.value)) + parseInt(b.getAttribute('data-step'), 10));
      input.value = v || '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Farbwechsel: Theme setzt Variante/Button neu -> mehrfach nachrechnen
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) {
        scheduleRender(); setTimeout(render, 700); setTimeout(render, 1600);
      }
    });
    // Komplettsets: Beim Laden ist das Hauptbild zu sehen. Klickt der Kunde die bereits markierte Farbe an,
    // feuert der Browser kein "change" -> hier nachholen, damit das Farbbild erscheint.
    if (isSet) {
      var wasChecked = null;
      var radioFrom = function (t) {
        if (!t.closest || !t.closest('variant-selects')) return null;
        if (t.matches('input[type="radio"]')) return t;
        var l = t.closest('label');
        return l && l.htmlFor ? document.getElementById(l.htmlFor) : null;
      };
      document.addEventListener('pointerdown', function (e) {
        var inp = radioFrom(e.target);
        wasChecked = inp && inp.checked ? inp : null;
      }, true);
      document.addEventListener('click', function (e) {
        var inp = radioFrom(e.target);
        if (inp && inp === wasChecked && !/[?&]variant=/.test(location.search)) {
          wasChecked = null;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
